var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61763 20.2666C8.1093 20.2666 7.6343 20.0916 7.29263 19.7666C6.8593 19.3583 6.65097 18.7416 6.72597 18.075L7.0343 15.375C7.09263 14.8666 7.40097 14.1916 7.7593 13.825L14.601 6.58329C16.3093 4.77496 18.0926 4.72496 19.901 6.43329C21.7093 8.14163 21.7593 9.92496 20.051 11.7333L13.2093 18.975C12.8593 19.35 12.2093 19.7 11.701 19.7833L9.01763 20.2416C8.87597 20.25 8.75097 20.2666 8.61763 20.2666ZM17.276 6.42496C16.6343 6.42496 16.076 6.82496 15.5093 7.42496L8.66763 14.675C8.50097 14.85 8.3093 15.2666 8.27597 15.5083L7.96763 18.2083C7.9343 18.4833 8.00097 18.7083 8.15097 18.85C8.30097 18.9916 8.52597 19.0416 8.80097 19L11.4843 18.5416C11.726 18.5 12.126 18.2833 12.2926 18.1083L19.1343 10.8666C20.1676 9.76663 20.5426 8.74996 19.0343 7.33329C18.3676 6.69163 17.7926 6.42496 17.276 6.42496Z",
    fill: "#939AA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4497 13.125C18.433 13.125 18.408 13.125 18.3914 13.125C15.7914 12.8667 13.6997 10.8917 13.2997 8.30837C13.2497 7.9667 13.483 7.65004 13.8247 7.5917C14.1664 7.5417 14.483 7.77504 14.5414 8.1167C14.858 10.1334 16.4914 11.6834 18.5247 11.8834C18.8664 11.9167 19.1164 12.225 19.083 12.5667C19.0414 12.8834 18.7664 13.125 18.4497 13.125Z",
    fill: "#939AA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.9585H6.5C6.15833 22.9585 5.875 22.6752 5.875 22.3335C5.875 21.9918 6.15833 21.7085 6.5 21.7085H21.5C21.8417 21.7085 22.125 21.9918 22.125 22.3335C22.125 22.6752 21.8417 22.9585 21.5 22.9585Z",
    fill: "#939AA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c6ba9f80.svg";
export { ForwardRef as ReactComponent };